import React, { useContext, useState } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Theme } from '@mui/material'
import ProductContext from '../context/ProductContext'
import { Link } from 'react-router-dom'
import { getProductUrl } from '../../../urls'

const useStyles = makeStyles((theme: Theme) => ({
  item: {
    backgroundColor: '#fff',
    width: '80px',
    height: '80px',
    borderRadius: '4px',
    border: '1px solid #d8d8d8',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain',
    },
    '&:hover': {
      borderColor: '#3d53f9',
    },
  },
}))

const SimilarProductsCard = () => {
  const classes = useStyles()
  const { reflection, setIsOpenProductDialog, isModal } = useContext(ProductContext)
  const [selectedProduct, setSelectedProduct] = useState(null)

  const similarSpecifics = reflection.product.similarSpecifics
  if (!similarSpecifics.length) return null
  return (
    <div className='my-30'>
      <div className='mb-8 overflow-hidden whitespace-nowrap overflow-ellipsis'>
        <span className='font-medium text-15'>Similar Product</span>
        {selectedProduct && <span>: {selectedProduct}</span>}
      </div>
      <div className='flex flex-wrap gap-8'>
        {similarSpecifics.map(node => {
          const spec = node.specifics[0]
          if (!spec) return null
          return (
            <Link
              key={node.id}
              onClick={e => {
                if (isModal) {
                  e.preventDefault()
                  setIsOpenProductDialog({ pk: spec.pk, slug: spec.slug })
                }
              }}
              to={getProductUrl(spec.slug, spec.pk)}
              onMouseEnter={() => setSelectedProduct(spec.shortName || spec.name)}
              onMouseLeave={() => setSelectedProduct(null)}
            >
              <div className={classes.item}>
                <img src={node.images[0]?.thumbnailUrl} alt={spec.name} />
              </div>
            </Link>
          )
        })}
      </div>
    </div>
  )
}

export default SimilarProductsCard
